import { useI18n } from 'vue-i18n';

// Maps a caught axios/API error into one of a small set of friendly, actionable
// messages instead of surfacing raw technical detail (401, timeout, "Network Error",
// generic Axios error text) to the user. Backend business errors from the Communication
// layer (e.g. "WhatsApp instance is disconnected") are already human-readable — those
// are passed through as-is when present, since they're more specific than any of the
// generic buckets below.
export function useCommunicationErrorMessage() {
  const { t } = useI18n();

  const friendlyMessage = error => {
    const backendMessage = error?.response?.data?.error;
    if (backendMessage) {
      return backendMessage;
    }

    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      return t('COMMUNICATION_CONNECTION.ERRORS.AUTHENTICATION_FAILED');
    }
    if (status === 404) {
      return t('COMMUNICATION_CONNECTION.ERRORS.NOT_FOUND');
    }

    const isTimeout =
      error?.code === 'ECONNABORTED' || /timeout/i.test(error?.message || '');
    if (isTimeout) {
      return t('COMMUNICATION_CONNECTION.ERRORS.TIMEOUT');
    }

    // axios sets no `response` at all for a request that never got a reply
    // (DNS failure, connection refused, CORS block, offline) — its own message
    // is usually the unhelpful literal string "Network Error".
    if (!error?.response) {
      return t('COMMUNICATION_CONNECTION.ERRORS.GATEWAY_UNAVAILABLE');
    }

    return t('COMMUNICATION_CONNECTION.ERRORS.GENERIC');
  };

  return { friendlyMessage };
}
